<template>
	<transition
			appear
			:appear-active-class="$_crdCrsl_styleCardCarouselAnimation()">
		<v-row no-gutters>
			<v-col>
				<v-carousel
						:class="$_crdCrsl_styleCarouselFlat ? 'flat_' : ''"

						:continuous="$_crdCrsl_styleCarouselContinuous"
						:cycle="$_crdCrsl_styleCarouselCycle"
						:dark="$_crdCrsl_styleCarouselDark"
						:delimiter-icon="$_crdCrsl_styleCarouselDelimiterIcon"
						:hide-delimiter-background="$_crdCrsl_styleCarouselHideDelimiterBackground"
						:hide-delimiters="$_crdCrsl_styleCarouselHideDelimiters"
						:interval="$_crdCrsl_styleCarouselInterval"
						:light="$_crdCrsl_styleCarouselLight"
						:next-icon="$_crdCrsl_styleCarouselNextIcon"
						:prev-icon="$_crdCrsl_styleCarouselPrevIcon"
						:progress="$_crdCrsl_styleCarouselProgress"
						:progress-color="$_crdCrsl_styleCarouselProgressColor"
						:show-arrows="$_crdCrsl_styleCarouselShowArrows"
						:show-arrows-on-hover="$_crdCrsl_styleCarouselShowArrowsOnHover"
						:touchless="$_crdCrsl_styleCarouselTouchless">
					<template v-for="(carouselVals, carouselKey) in sortObject($_crdCrsl_carousel, 'order')">
						<v-carousel-item :key="carouselKey">
							<v-card	color="transparent"
									tile>
								<v-img	contain
										position="center"
										:aspect-ratio="$_crdCrsl_styleContentImageAspectRatio(carouselVals) || 16/9"
										:src="$_crdCrsl_styleContentImageUrl(carouselVals)" />
							</v-card>
						</v-carousel-item>
					</template>
				</v-carousel>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'CardCarousel',
		props: {
			contentKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			// carousel
			$_crdCrsl_carousel() {
				const self_ = this;
				return self_.contents[self_.contentKey].carousel
			},
			// state
			$_crdCrsl_stateAppIsMobileScreen() {
				const self_ = this;
				return self_.getAppState('isMobileScreen')
			},
			// style
			$_crdCrsl_styleCardCarousel() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'cardCarousel')
				}
			},
			$_crdCrsl_styleCardCarouselAnimation() {
				const self_ = this;
				return () => {
					const carousel_ = self_.$_crdCrsl_styleCardCarousel()
					if(self_.isFalse(carousel_)) { return null }
					return self_.getStylesVal(carousel_.animation)
				}
			},
			$_crdCrsl_styleCarousel() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'carousel')
			},
			$_crdCrsl_styleCarouselContinuous() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.continuous)
			},
			$_crdCrsl_styleCarouselCycle() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.cycle)
			},
			$_crdCrsl_styleCarouselDark() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.dark)
			},
			$_crdCrsl_styleCarouselDelimiterIcon() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.delimiterIcon)
			},
			$_crdCrsl_styleCarouselFlat() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.flat)
			},
			$_crdCrsl_styleCarouselHideDelimiters() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.hideDelimiters)
			},
			$_crdCrsl_styleCarouselHideDelimiterBackground() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.hideDelimiterBackground)
			},
			$_crdCrsl_styleCarouselInterval() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.interval)
			},
			$_crdCrsl_styleCarouselLight() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.light)
			},
			$_crdCrsl_styleCarouselNextIcon() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.nextIcon)
			},
			$_crdCrsl_styleCarouselPrevIcon() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.prevIcon)
			},
			$_crdCrsl_styleCarouselProgress() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.progress)
			},
			$_crdCrsl_styleCarouselProgressColor() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.progressColor)
			},
			$_crdCrsl_styleCarouselShowArrows() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.showArrows)
			},
			$_crdCrsl_styleCarouselShowArrowsOnHover() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.showArrowsOnHover)
			},
			$_crdCrsl_styleCarouselTouchless() {
				const self_ = this;
				const carousel_ = self_.$_crdCrsl_styleCarousel;
				if(self_.isFalse(carousel_)) { return null }
				return self_.getStylesVal(carousel_.touchless)
			},
			// (content)
			$_crdCrsl_styleContentImage() {
				return contentVals => {
					return contentVals.image
				}
			},
			$_crdCrsl_styleContentImageAspectRatio() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_crdCrsl_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.aspectRatio)
				}
			},
			$_crdCrsl_styleContentImageUrl() {
				const self_ = this;
				return contentVals => {
					const image_ = self_.$_crdCrsl_styleContentImage(contentVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		}
	}
</script>

<style scoped>
	.flat_.v-carousel {
		box-shadow: none;
	}
</style>
